<template>
    <div class="p-3">
        <h3>RL 3.3 Kegiatan Pelayanan Rawat Darurat</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Rawat Darurat" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                },
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-rawat-darurat',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        width: 70,
                        hozAlign: "center",
                        frozen: true,

                    },
                    {
                        title: "Jenis Pelayanan",
                        field: "jenis_pelayanan",
                        width: 250,
                        frozen: true,

                    },
                    {
                        title: "Total Pasien",
                        columns: [
                            {
                                title: "Rujukan",
                                field: "total_rujukan",
                                hozAlign: "center",
                            },
                            {
                                title: "Non Rujukan",
                                field: "total_non_rujukan",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Tindak Lanjut Pelayanan",
                        columns: [
                            {
                                title: "Dirawat",
                                field: "dirawat",
                                hozAlign: "center",
                            },
                            {
                                title: "Dirujuk",
                                field: "dirujuk",
                                hozAlign: "center",
                            },
                            {
                                title: "Pulang",
                                field: "pulang",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Mati di IGD",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "mati_igd_laki",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "mati_igd_perempuan",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "DOA",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "doa_laki",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "doa_perempuan",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "Luka-luka",
                        columns: [
                            {
                                title: "Laki-laki",
                                field: "luka_laki",
                                hozAlign: "center",
                            },
                            {
                                title: "Perempuan",
                                field: "luka_perempuan",
                                hozAlign: "center",
                            }
                        ]
                    },
                    {
                        title: "False Emergency",
                        field: "false_emergency",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
